<template>
  <Page title="Daftar Kegiatan">
    <div style="padding:20px; background:white;">
      <div style="display:flex">
        <Select dbref="MST.SelBalai" width="500px" :value.sync="BalaiID" />
        <v-spacer />
        <v-btn small color="primary">IMPORT DATA KEGIATAN</v-btn>
      </div>
      <Grid
        :datagrid.sync="datagrid"
        dbref="MST.DaftarKegiatan"
        :dbparams.sync="params"
        height="calc(100vh - 190px)"
        :columns="[
          {
            name: 'Kode',
            value: 'KodeKegiatan',
            editable: {
              com: 'Input',
            },
          },
          {
            name: 'Kegiatan',
            value: 'NamaKegiatan',
            editable: {
              com: 'Input',
            },
          },
        ]"
      >
        <template v-slot:row-NamaKegiatan="{ row }">
          <div :class="row.ClassName">{{ row.NamaKegiatan }}</div>
        </template>
      </Grid>
    </div>
  </Page>
</template>
<script>
export default {
  data: () => ({
    BalaiID: 0,
    datagrid: [],
  }),
  computed: {
    params() {
      return { _BalaiID: this.BalaiID }
    },
  },
  methods: {
    getClass(kegiatan) {
      if (kegiatan.match(/Sub Sub/i)) {
        return 'padleft-20'
      } else if (kegiatan.match(/Sub /i)) {
        return 'padleft-10'
      } else {
        return ''
      }
    },
  },
}
</script>
<style lang="scss">
.padleft-10 {
  padding-left: 10px;
}
.padleft-20 {
  padding-left: 20px;
}
</style>
